import { create, tsx } from '@dojo/framework/core/vdom';
import { RenderResult } from '@dojo/framework/core/interfaces';

import * as css from './Page.m.css';

interface PageChildren {
	head?: RenderResult;
	hero: {
		background: RenderResult;
		content: RenderResult;
	};
	page: RenderResult;
}

interface PageProperties {
	fade?: boolean;
}

const factory = create().properties<PageProperties>().children<PageChildren>();

export const Page = factory(function Page({ children, properties }) {
	const [
		{
			head,
			hero: { background, content: hero },
			page
		}
	] = children();
	const { fade } = properties();
	return (
		<div classes={[css.root]}>
			{head}
			<div classes={[css.background, fade && css.fixed]}>{background}</div>
			{hero}
			<div classes={[css.content, fade && css.fade]}>{page}</div>
		</div>
	);
});

export default Page;
